import Layout from "layout/layout";

import { useEffect, useState } from "react";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi } from "utils";

import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";
import { Card } from "components/ui/card";
import AccountDetailLayout from "layout/account-detail-layout/AccountDetailLayout";

export default function Events() {
  const { token } = useAppSelector((state) => state.auth);

  // const initUpdateProfileInfo = async () => {
  //   try {
  //     const url = `${RouteApi.getUpdateProfileInformation}token=${token}`;
  //     const data = {
  //       user_id: userProfileDetail.user.id,
  //     };
  //     const response = await RequestApi(url, { data });
  //     if (response.status === "success") {
  //       setUserUpdateProfileInformation(response.user);
  //     }
  //   } catch (error: any) {
  //     AppLog({ message: error.toString(), status: StatusMsg.error });
  //   }
  // };

  return (
    <AccountDetailLayout>
      <div className="min-h-[calc(100vh-120px)]">
        <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm">Events</h1>
        <p className="text-muted-foreground lg:text-md md:text-md text-[13px]">Plan, Organize, and Execute Successful Business Events</p>
      </div>
    </AccountDetailLayout>
  );
}
